var ProgressBarView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/progressbar');

View = require('views/base/view');

module.exports = ProgressBarView = (function(_super) {
  __extends(ProgressBarView, _super);

  function ProgressBarView() {
    _ref = ProgressBarView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  ProgressBarView.prototype.template = template;

  ProgressBarView.prototype["class"] = 'progressbar';

  ProgressBarView.prototype.autoRender = true;

  ProgressBarView.prototype.listen = {
    'progressUpdate mediator': 'updateProgress'
  };

  ProgressBarView.prototype.updateProgress = function(progress) {
    if (progress >= 1) {
      this.$el.hide();
      return;
    }
    progress = Math.round(progress * 100) + '%';
    this.$('.meter div').css({
      width: progress
    });
    return this.$('.progress span').html(progress);
  };

  return ProgressBarView;

})(View);
